import FamilyMembers from './FamilyMembers';

export default {
  FamilyMembers,
};
